import {userConstants} from '../_constants';

export function senderCityNpWarehouse(state = {}, action) {
  switch (action.type) {
    case userConstants.UPDATE_SENDER_CITY_NP_WAREHOUSE_REQUEST:
      return {
        loading: true,
      };
    case userConstants.UPDATE_SENDER_CITY_NP_WAREHOUSE_SUCCESS:
      return {
        data: action.data.data,
      };
    case userConstants.UPDATE_SENDER_CITY_NP_WAREHOUSE_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}